import { tagGroups } from "@/mocks/home";

export default function TagIndex() {
  return (
    <section id="tags" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            标签索引
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            按标签回到上面的分区
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            这些是本页围绕的核心词。点击任意标签，可以快速回到对应的介绍位置，继续往下看。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {tagGroups.map((group) => (
            <div
              key={group.title}
              className="rounded-lg border border-background-200/70 bg-background-100 p-5"
            >
              <h3 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
                <i className="ri-price-tag-3-line text-primary-600" />
                {group.title}
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {group.tags.map((tag) => (
                  <a
                    key={tag}
                    href="#films"
                    className="cursor-pointer whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}